import { connect } from 'react-redux'
import AceEditor from 'react-ace'

JsonInput = ({ value, darkModeEnabled, props... }) ->

  <div style={{ borderRadius: '10px', border: 'solid 1px #eee', padding: "2px"}}>
    <AceEditor
      {props...}
      style={{ width: '100%', borderRadius: 9 }}
      theme={darkModeEnabled && "solarized_dark" || "solarized_light"}
      showGutter={true}
      mode="json"
      defaultValue={JSON.stringify(value, null, 2)}
      font={14}
      setOptions={{
        highlightActiveLine: false,
        highlightGutterLine: false,
        showLineNumbers: false
        maxLines: 1000,
        autoScrollEditorIntoView: false,
      }}
    />
  </div>

mapStateToProps = ({ explore }) -> {
  darkModeEnabled: explore.darkModeEnabled
}

export default connect(mapStateToProps)(JsonInput)
